module.exports = __webpack_public_path__ + "static/media/Priority.d7aed303.pdf";